<template>
    <section class="section section-shaped section-lg my-0 pt-0">
        <Loading v-if="loading"/>
        <div class="shape shape-style-1 shape-primary alpha-4">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </div>
        <div class="container pt-lg-md">
            <div class="row justify-content-center">
                <div class="col-lg-5">
                    <card type="secondary" shadow
                          header-classes="bg-white pb-5 "
                          body-classes="pt-0"
                          class="border-0">
                        <template>
                            <div class="text-muted text-center">
                           
                                <lottie-animation
                                    path="register.json"
                                    :width=130
                                />
                                 <div class="h5"> Register For Staff Attendance</div>
                                 <base-alert type="default" dismissible v-if="error">
                                    <span class="alert-inner--text"><strong>Error!</strong> {{ error }} </span>
                                    <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </base-alert>
                            </div>
                           
                        </template>
                        <template>
                           
                            <form role="form" v-on:keyup.enter="onSubmit">
                                <div class="text-danger text-center" >
                                    <small v-if="!$v.form.name.required && $v.form.name.$anyDirty">Name is required</small>
                                    <small v-if="!$v.form.name.minLength">Name must have at least {{$v.form.name.$params.minLength.min}} letters.</small>
                                </div>
                                <base-input alternative
                                            v-model="form.name"
                                            class="mb-3"
                                            placeholder="Company Name"
                                            :class="!$v.form.name.required && $v.form.name.$anyDirty || !$v.form.name.minLength ? 'shake border border-danger' : !$v.form.name.$invalid ? 'border border-success' : '' "
                                            :addon-left-icon="!$v.form.name.required && $v.form.name.$anyDirty || !$v.form.name.minLength ? 'ni ni-circle-08  text-danger' :'ni ni-circle-08' " 
                                            >
                                </base-input>
                                
                                <div class="text-danger text-center">
                                    <small v-if="!$v.form.address.required && $v.form.address.$anyDirty">Address is required</small>
                                     <small v-if="!$v.form.address.minLength">Address must have at least {{$v.form.address.$params.minLength.min}} letters.</small>
                                </div>
                                <base-input alternative
                                            v-model="form.address"
                                            class="mb-3"
                                            :class="!$v.form.address.required && $v.form.address.$anyDirty || !$v.form.address.minLength ? 'shake border border-danger' :  !$v.form.address.$invalid ? 'border border-success' : '' "
                                            placeholder="Address"
                                            :addon-left-icon="!$v.form.address.required && $v.form.address.$anyDirty || !$v.form.address.minLength ? 'ni ni-pin-3  text-danger' :'ni ni-pin-3' " 
                                          
                                            >
                                </base-input>

                                <div class="text-danger text-center">
                                    <small v-if="!$v.form.email.required && $v.form.email.$anyDirty">Email is required</small>
                                    <small v-if="!$v.form.email.email">Email is invalid</small> 
                                </div>
                                <base-input alternative
                                            v-model="form.email"
                                            :class="!$v.form.email.required && $v.form.email.$anyDirty || !$v.form.email.email ? 'shake border border-danger' : !$v.form.email.$invalid ? 'border border-success' : '' "
                                            type="email"
                                            placeholder="Company Email"
                                            :addon-left-icon="!$v.form.email.required && $v.form.email.$anyDirty || !$v.form.email.email ? 'ni ni-email-83  text-danger' :'ni ni-email-83' " >
                                </base-input>
                                <b-form-group
                                description="Attach company logo here">
                                
                                    <base-input alternative
                                                type="file"
                                                accept="image/*"
                                                addon-left-icon="ni ni-album-2">
                                                
                                    </base-input>
                               
                                </b-form-group>
                          
                                <div class="text-center">
                                     
                                    <base-button type="primary" @click="onSubmit" class="my-1">Create account</base-button>
                                </div>
                            </form>
                        </template>
                    </card>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import LottieAnimation from "lottie-vuejs/src/LottieAnimation.vue"
import { required, email, minLength } from 'vuelidate/lib/validators'
import Loading from "./Loading.vue"

export default {
    components:{
        LottieAnimation,
        Loading
    },
    data(){
        return{
                form:{
                    name:'',
                    email:'',
                    address:''
                },
                loading:false,
                error:''
        }
    },
    validations () {
    return {
      error:'',
      loading:false,
      form:{
        email: { required, email }, 
        name: { required, minLength: minLength(5) },
        address: { required, minLength: minLength(5) }
      }
      
    }
  },
  methods:{
      onSubmit(){
            
            this.$v.$touch();
            if(this.$v.$error) return

            // to form submit after this
            this.loading=true
            // fetch(`${process.env.VUE_APP_APIURL}/login/tasks`, 
            // {
            //     method:'POST',
            //     headers: {
            //         'Content-Type': 'application/json',
            //     },
            //     body : JSON.stringify({ "email":this.email , "password":this.password })
            // })
            // .then(response => response.json())
            // .then(data => {

            //     setTimeout(() => {

            //         this.loading=false
            //         if(data.success){

                  
                    
                    
            //         }else{

            //         this.error = data.message ?  data.message : data.error
            //       }
                    
            //         }, 2000);

                
                
            // })
            // .catch(err => {
            //     setTimeout(() => {
            //         this.loading=false
            //         this.error="Something went wrong."
            //     }, 2000);
            // });

      }

  }
};
</script>
<style>


</style>
